<template>
  <div>
    <nav class="navbar navbar-light bg-white border w-100">
      <b-button @click="toggleCollapse" variant="outline-secondary"><span class="navbar-toggler-icon"></span></b-button>

      <a @click="$router.push({name:'user'})" class="navbar-brand w-50 d-block mx-auto">
        <img src="../../assets/logo.jpg" class="img-fluid" style="max-height: 80px" alt="">
      </a>
    </nav>

    <b-collapse v-model="showCollapse">
      <b-card class="collapse-card">
        <ul class="collapse-list">
          <li v-for="item in list" :key="item.id" @click="goPage(item)">{{item.name}}</li>
        </ul>
      </b-card>
    </b-collapse>
  </div>
</template>


<script>
// let lang = 'Language'
export default {
  name: "headerPage",
  data(){
    return{
      showCollapse: false,
      list:[
        {name:'首页',id:0,link: 'home'},
        {name:'使用教程',id:1,link:'tutorials'},
        {name:'下载客户端',id:2,link:'downLoad'},
        {name:'账户充值',id:3,link:'money'},
        {name:'卡密使用',id:4,link: 'kamil'},
        {name:'退出登录',id:5,link:'home'},
      ]
    }
  },
  methods: {
    toggleCollapse() {
      this.showCollapse = !this.showCollapse;
    },
    goPage(item){
      this.showCollapse = false
      if (item.id===5) {
        localStorage.removeItem('JDY-Jwt-Token')
        localStorage.removeItem('JDY-Jwt-User')
      }
      this.$router.push({name:item.link})
    }
  }
}
</script>

<style scoped>
.collapse-card {
  background-color: white;
  padding: 10px 0;
  border: 1px solid #ccc;
}

.collapse-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.collapse-list li {
  margin-bottom: 10px;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
}

.collapse-list li:nth-child(6){
  margin: 0;
}

.collapse-list li:hover {
  background-color: #f4f4f4;
}
</style>